import {ioStandardAction} from 'Core/store/actions/io';
import {sortBy} from 'lodash';
import {getArray, getNumber, getString} from 'Core/helpers/data';
import {getAppLocaleCode} from 'Core/helpers/locale';

export const fetchTimezonesAction = abortCallback => dispatch => {
	return ioStandardAction(
		abortCallback,
		'defaultAuthorizedApi',
		`general/get-time-zones?locale=${getAppLocaleCode()}`,
	)(dispatch)
		.then(res => sortBy(getArray(res, 'data'), ['utcOffset'])
			.filter(i => !getString(i, 'id').startsWith('Etc/') && !getString(i, 'id').startsWith('SystemV/'))
			.map(i => ({
				label: (
					`(UTC${getNumber(i, 'utcOffset') >= 0 ? '+' : ''}${getNumber(i, 'utcOffset')}) ` +
					`${getString(i, 'id').replaceAll('_', ' ')}`
					+ ` - ${getString(i, 'name')}`
				),
				offset: getNumber(i, 'utcOffset'),
				value: getString(i, 'id')
			})));
};